'use strict';

const i18n = require('i18next');
const Mn = require('backbone.marionette');
const Template = require('./announcement.hbs');

module.exports = Mn.View.extend({
    template: Template,

    templateContext: function() {
        return {
            categoryType: this.model.getCategoryName(),
            category: i18n.t(`feedback:announcement.category.${this.model.getCategoryName()}`)
        };
    }
});



// WEBPACK FOOTER //
// ./feedback/ui/header/announcement.js